// extracted by mini-css-extract-plugin
module.exports = {"navbarContainer":"navbar_navbarContainer__yqhWU","desktopMenu":"navbar_desktopMenu__q5ZRg","mobileMenu":"navbar_mobileMenu__lIDgy"};